import Request from "@/common/net/request.js";
const request = new Request();
// 获取司机钱包列表
export function getDriverPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/driver/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 获取代理商钱包列表
export function getAgentPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/agent/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 获取服务商钱包列表
export function getSupplierPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/supplier/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/balance/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 查询指定用户的钱包流水列表
export function getPageData(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/records`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 提现处理
export function handleWithdraw(data) {
  return request.send({
    url: `/pmy/sys/web/withdraw/handle`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机钱包总览
export function getDriverOverview(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/driver/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商钱包总览
export function getAgentOverview(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/agent/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机充值
export function rechargeDriver(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/recharge/user`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 代理商充值
export function rechargeCompany(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/recharge/company`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 服务商钱包总览
export function getSupplerOverview(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/supplier/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机流水列表
export function getDriverWalletPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/driver/wallet/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商流水列表
export function getAgentWalletPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/agent/wallet/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商流水列表
export function getSupplierWalletPage(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/supplier/wallet/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 查询银行卡详情
export function bankInfo(userId) {
  return request.send({
    url: `/pmy/sys/wallet/web/bank-card?userId=${userId}`,
    method: "get"
  });
}
